import { pageNames } from '@atc/bonnet-paths';
import dealerSetPaidSearchIdCreator from './creators/dealerSetPaidSearchIdCreator';

export default dealerSetPaidSearchIdCreator({
    namespace: pageNames.DEALER_SEARCH,
    storePrefix: `${pageNames.DEALER_SEARCH}.`,
});
